export default "/images/d0d6679583f51b75a5b3f1dd9bfa8691.avif";